<script>
  import { page, inertia } from "@inertiajs/svelte";

  const pageMap = {
    home: $page.component === "Home",
    receipt: $page.component === "FindReceipt/Search",
    list: $page.component === "FindReceipt/List",
  };
</script>

<nav aria-label="breadcrumb" class="float-end">
  <ol class="breadcrumb">
    {#if $$slots.home}
      <li class="breadcrumb-item" class:active={pageMap.home ? "active" : ""}>
        <slot name="home"></slot>
        {#if !pageMap.home}
          <a
            href={window.route("home")}
            use:inertia
            class="link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
            >Home</a
          >
        {:else}
          Home
        {/if}
      </li>
    {/if}

    {#if $$slots.receipt}
      <li class="breadcrumb-item" class:active={pageMap ? "active" : ""}>
        <slot name="receipt"></slot>
        {#if !pageMap.receipt}
          <a
            href={window.route("receipt.index")}
            use:inertia
            class="link-offset-3-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
            >Receipt Search</a
          >
        {:else}
          Receipt Search
        {/if}
      </li>
    {/if}

    {#if $$slots.list}
      <li class="breadcrumb-item" class:active={pageMap ? "active" : ""}>
        <slot name="list"></slot>
        Search Results
      </li>
    {/if}
  </ol>
</nav>
